import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useDjangoAuth } from "../../context/DjangoAuthContext";
import { MdGTranslate, MdOutlineLogout, MdFilterTiltShift, MdAccountBox, MdFileCopy } from "react-icons/md";

const ProfileIconDropDown = (props) => {
    const { t: tProfile } = useTranslation(['profile']);
    const { logout } = useDjangoAuth();

    const [langIco, setLangIco] = useState('en');
    const role = props.role;
    const profileIconRef = props.profileIconRef;

    const handleLogout = async () => {
        await logout();
        window.location.href = "/";
    };


    const changeLang = () => {
        const lang = localStorage.getItem('i18nextLng');
        if(lang === 'fr') {
            i18next.changeLanguage('en');
            setLangIco('fr');
        } else {
            i18next.changeLanguage('fr');
            setLangIco('en');
        }
    };

  return (
    <div ref={profileIconRef} className={"profile-icon-dropdown-wrapper"}>
      <Link
        to={role === "customer" ? "/customer/profile" : "/caregiver/profile"}
        className={"profile-dropdown-items"}
      >

          <MdAccountBox  style={{marginRight: 5}}/> {tProfile('Profile')}
      </Link>
      <Link
        to={role === "customer" ? "/customer/visits" : "/caregiver/shifts"}
        className={"profile-dropdown-items"}
      >
          <MdFilterTiltShift style={{marginRight: 5}}/> {role === "customer" ? tProfile('Visits') : tProfile('Shifts')}
      </Link>
      <Link
        to={role === "customer" ? "/customer/files" : "/caregiver/files"}
        className={"profile-dropdown-items"}
      >
          <MdFileCopy style={{marginRight: 5}}/> {tProfile('Files')}
      </Link>
      <div className={"profile-dropdown-items"} onClick={changeLang}>
          <MdGTranslate style={{marginRight: 5}}/> {tProfile('Switch to...')}
      </div>
        <div className={"profile-dropdown-items"} style={{borderTop: '1px solid #333'}} onClick={handleLogout}>
            <MdOutlineLogout style={{marginRight: 5}}/> {tProfile('Log Out')}
        </div>

    </div>
  );
};

export default ProfileIconDropDown;
